import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
} from "@mui/material";
import { Link } from "react-router-dom";
import TAGlogo from "assets/images/TAGlogo.svg";
import lockIcon from "assets/images/lockimage.svg";
import mailIcon from "assets/images/mailIcon.svg";
import phoneIcon from "assets/images/phoneIcon.svg";

function LockedAccount() {
  return (
    <div>
      <Box className="box-style">
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <img className="login-logo" src={TAGlogo} alt="Error in loading" />
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <Grid
        container
        spacing={2}
        direction="column"
        alignItems="center"
        justify="center"
        className="form-alignment"
      >
        <Grid item xs={12}>
          <Grid item xs={12}>
            <Card className="lockAccount-card">
              <CardContent className="lockAccount-form-content">
                <Typography className="lockAccount-card-header">
                  <div className="default-card-header-padding">
                    <img src={lockIcon} alt="" />
                    <h2 className="default-card-header-text">Locked Account</h2>
                  </div>
                </Typography>
              </CardContent>
              <CardContent className="remove">
                <div className="default-card-body-padding">
                  <span className="font-bold">
                    Your organization’s account has been locked. Please contact
                    TAG to address this issue.
                  </span>
                </div>
                <div>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <div>
                        <img src={mailIcon} alt="" />
                        <div>
                          <span className="default-card-body-text">
                            <div className="default-card-body-top-padding">
                              info@taginc.com
                            </div>
                          </span>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <div>
                        <img src={phoneIcon} alt="" />

                        <p className="default-card-body-text">
                          <span className="default-card-body-top-padding">
                            +1 (949) 723-2220
                          </span>
                        </p>
                      </div>
                    </Grid>
                  </Grid>
                </div>
                <div className="whole-padding">
                  <Link className="dafault-font-family" to="/">
                    Return to log in
                  </Link>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default LockedAccount;
